import { render, staticRenderFns } from "./SidebarSimple.vue?vue&type=template&id=16b82ec6&"
import script from "./SidebarSimple.vue?vue&type=script&lang=js&"
export * from "./SidebarSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports